export default function () {
  if (document.getElementById('address-contact-list-app')) {
    // eslint-disable-next-line no-unused-expressions
    import(/* webpackChunkName: "address-contact-vue-app" */ '@organisms/address-contact/main');
  }
}
